const ADD_FAQ = {
  ADD_PAGE_HEADER_TITLE: 'افزودن دسته‌بندی سوال متداول',
  ADD_PAGE_HEADER_DESC:
    'در این بخش، سوالات پرتکراری را که معمولاً زیاد پرسیده می‌شوند، اضافه کنید تا لیست کاملی از سوالات متداول داشته باشید. این قابلیت به شما کمک می‌کند تا کاربران را سریع‌تر راهنمایی کرده و پاسخ سوالاتشان را حتی پیش از پرسیدن آنها، در اختیارشان قرار دهید.',
  ADD_FAQ_TITLE_INPUT_PLACEHOLDER: 'عنوان دسته‌بندی',
  ADD_FAQ_DESC_INPUT_PLACEHOLDER: 'توضیحات',
  ADD_PAGE_SUBMIT_BTN_EDIT_LABEL: 'ویرایش',
  ADD_PAGE_SUBMIT_BTN_ADD_LABEL: 'افزودن',
  ADD_PAGE_NO_QUESTION_MSG: 'سوالی ایجاد نشده است',
  ADD_FIELD_MAX_CHAR_EXCEED_ERROR: 'تعداد کاراکترها مجاز نمیباشد',
  ADD_FAQ_ACTIVE_SWITCH_LABEL: 'وضعیت',
  ADD_QUESTIONS_LABEL: 'سوالات',
  ADD_QUESTION_ADD_BTN_LABEL: 'افزودن',
  ADD_QUESTION_EDIT_BTN_LABEL: 'ویرایش',
  ADD_QUESTION_TITLE_PLACEHOLDER: 'عنوان سوال',
  ADD_QUESTION_DESC_PLACEHOLDER: 'توضیحات',
  ADD_DELETE_QUESTION_MODAL_MSG: 'آیا از حذف این پرسش اطمینان دارید؟',
  ADD_PAGE_DELTE_QUESTION_MODAL_BTN: 'تایید',
  ADD_PAGE_DELTE_QUESTION_DESC_TTILE: 'متن پیام',
  ERROR_MESSAGE: 'پر کردن تمامی فیلدها الزامی می‌باشد!',
  TITLE_ERROR_MESSAGE: 'نوشتن عنوان دسته بندی الزامی می‌باشد!',
  DESC_ERROR_MESSAGE: 'نوشتن توضیحات الزامی می‌باشد!',
  BACK: 'بازگشت'
};

export default ADD_FAQ;
